import { Component, inject, model } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { ExportModalComponent } from '../public/modals/export-modal.component'
import { IdrInvestigationService } from './idr-investigation.service'
import { FilterParams, SortParams } from '../shared/utilities/http-params'

export type IdrExportArgs = Readonly<{
  columns: readonly string[],
  filters: readonly FilterParams[],
  order: readonly SortParams[],
}>

@Component({
  imports: [ExportModalComponent],
  selector: 'app-idr-export-modal',
  template: `
      <app-export-modal
        title='Export IDR Results'
        [(cancelled)]="cancelled"  
        (download)="onDownload()"
      />
  `,
})
export class IdrExportModalComponent {
  private readonly activeModal = inject(NgbActiveModal)
  private readonly idrService = inject(IdrInvestigationService)

  protected readonly cancelled = model(false)
  private args!: IdrExportArgs

  init(args: IdrExportArgs) {
    this.args = args
  }

  protected onDownload() {
    this.idrService.exportResults(this.args!, this.cancelled).subscribe(() => {
      if (!this.cancelled()) {
        this.activeModal.dismiss()
      }
    })
  }
}
